import { registerServiceWorker } from "@accessinformatica/service-worker";
import ReactDOM from "react-dom";
import packagejson from "../package.json";
import App from "./App";
import { logout } from "./redux/actions/auth";
import { persistor, store } from "./redux/store/store";

registerServiceWorker({
  store,
  version: packagejson.version,
  path: "service-worker.js?v=2",
  persistor,
  onControllerChange: () => {
    store.dispatch(logout());
    return Promise.resolve();
  },
});

ReactDOM.render(<App />, document.getElementById("root"));
